module.exports = __webpack_public_path__ + "static/images/cover_C11.9927073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C11.png
// module id = R0va
// module chunks = 8